import {
    AppBar,
    Box,
    IconButton,
    Toolbar,
    Typography
} from "@mui/material";
import React, { ReactNode } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useGetUserInfoQuery } from "../../../services/grace";
import GDGAppBarButton from "./GDGAppBarButton";
import { useHistory } from "react-router-dom";

export type GDGAppBarProps = {
    title: string;
    drawerWidth?: number;
    children?: ReactNode;
    tabs?: ReactNode;
    onClose?: () => void;
};

export default function GDGAppBar(props: GDGAppBarProps): JSX.Element {
    const {
        title,
        drawerWidth = 240,
        tabs,
        children,
        onClose,
    } = props;

    const history = useHistory();

    const {
        data: userData,
        refetch: refetchUserData,
    } = useGetUserInfoQuery();

    const handleLogout = () => {
        history.push("/logout");
    };

    // Get today's date
    const today = new Date();
    // Format the greeting
    var hours = today.getHours();
    let message: string;
    if (hours < 12) {
        message = "Good morning";
    } else if (hours < 18) {
        message = "Good afternoon";
    } else {
        message = "Good evening";
    }

    return (
        <div style={{minHeight: '100px'}}>
            <AppBar position="fixed" sx={{
                marginLeft: `${drawerWidth}px`,
                width: `calc(100% - ${drawerWidth}px)`,
                boxShadow: '0 0'
            }}>
                <Toolbar variant="primary">
                    <Typography variant="h6" fontWeight="bold" fontSize="18px">
                        {message}, {userData?.login}
                    </Typography>
                    <Box sx={{ flex: 1 }}/>
                    <GDGAppBarButton
                        onClick={handleLogout}
                        text='Logout'
                        textColor="#FFF"
                        iconColor="#FFF"
                        icon={['fas', 'sign-out']}
                    />
                </Toolbar>
                <Toolbar variant="dense" >
                    {onClose !== undefined &&
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={() => onClose()}
                            aria-label="close"
                            size="large">
                            <FontAwesomeIcon icon={['far', 'times']} title='Close'/>
                        </IconButton>
                    }
                    <Typography variant="h6" fontWeight="bold" fontSize="18px">{title}</Typography>
                    <Box sx={{ flex: 1 }}/>
                    {children}
                </Toolbar>
                {tabs}
            </AppBar>

            { /* necessary for content to be below app bar */}
            { /* see: https://material-ui.com/components/app-bar/#fixed-placement */}
            <Toolbar/>
        </div>
    )
}
